import * as mutation from "./mutation-types";
import _ from "underscore";
import { stateMerge } from "vue-object-merge";
import { deepCopy } from "@/store/helpers";
import { getInitialState } from "./state";
import { getInitialPinnedCriteria } from "./helper";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },

  [mutation.SAVED_SEARCHES_GET_STARTED]() {},
  [mutation.SAVED_SEARCHES_GET_SUCCEEDED](state, allSavedSearches) {
    stateMerge(state.savedSearches.data, allSavedSearches);
    state.loaded = true;
  },
  [mutation.SAVED_SEARCHES_GET_FAILED]() {},
  [mutation.SAVED_SEARCHES_PRESELECTED_FILTER](state, filter) {
    state.preselectedFilter = filter;
  },
  [mutation.SAVED_SEARCHES_SAVE_STARTED]() {},
  [mutation.SAVED_SEARCHES_SAVE_SUCCEEDED]() {},
  [mutation.SAVED_SEARCHES_SAVE_FAILED]() {},
  [mutation.SAVED_SEARCHES_ADD](state, { module, name, criteria }) {
    const newFilter = { name, criteria: deepCopy(criteria) };
    state.savedSearches.data[module].push(newFilter);
  },
  [mutation.SAVED_SEARCHES_DELETE](state, { module, name }) {
    const index = _(state.savedSearches.data[module]).findIndex(ss => ss.name == name);
    if (index >= 0) {
      state.savedSearches.data[module].splice(index, 1);
    }
  },
  [mutation.SAVED_SEARCHES_MOVE_UP](state, { module, name }) {
    const index = _(state.savedSearches.data[module]).findIndex(ss => ss.name == name);
    if (index > 0) {
      const [removed] = state.savedSearches.data[module].splice(index, 1);
      state.savedSearches.data[module].splice(index - 1, 0, removed);
    }
  },
  [mutation.SAVED_SEARCHES_MOVE_DOWN](state, { module, name }) {
    const index = _(state.savedSearches.data[module]).findIndex(ss => ss.name == name);
    if (index != -1 && index < state.savedSearches.data[module].length - 1) {
      const [removed] = state.savedSearches.data[module].splice(index, 1);
      state.savedSearches.data[module].splice(index + 1, 0, removed);
    }
  },

  [mutation.PINNED_CRITERIA_ADD](state, { module, criteria }) {
    state.pinnedCriteria.data[module].push(criteria);
  },
  [mutation.PINNED_CRITERIA_REMOVE](state, { module, criteria }) {
    const pc = state.pinnedCriteria.data[module];
    const index = pc.indexOf(criteria);
    pc.splice(index, 1);
  },
  [mutation.PINNED_CRITERIA_GET_STARTED](state) {
    state.pinnedCriteria.loading = true;
  },
  [mutation.PINNED_CRITERIA_GET_SUCCEEDED](state, results) {
    state.pinnedCriteria.loading = false;
    state.pinnedCriteria.loaded = true;
    state.pinnedCriteria.data = results;
  },
  [mutation.PINNED_CRITERIA_GET_FAILED](state) {
    state.pinnedCriteria.loading = false;
    state.pinnedCriteria.loaded = false;
  },
  [mutation.PINNED_CRITERIA_SAVE_STARTED](state) {
    state.pinnedCriteria.saving = true;
  },
  [mutation.PINNED_CRITERIA_SAVE_SUCCEEDED](state) {
    state.pinnedCriteria.saving = false;
  },
  [mutation.PINNED_CRITERIA_SAVE_FAILED](state) {
    state.pinnedCriteria.saving = false;
  },
  [mutation.PINNED_CRITERIA_INITIAL_SETUP](state) {
    state.pinnedCriteria.data = getInitialPinnedCriteria();
  }
};
